import { CheckCircleOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ButtonProps, Col, FormItemProps, message, Modal, Tooltip } from "antd";
import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { PaginationsProps } from "api/model/Paging";
import { UserFeatureResponseModel } from "api/repositories/users/model/feature/UserFeatureResponseModel";
import { isEmpty, isUndefined } from "lodash";
import moment from "moment";
import { CSSProperties, Dispatch, ReactNode, SetStateAction } from "react";
import { strings } from "./localizeStrings";
import dayjs from "dayjs";

export const getStatus = (value: string | undefined | number) => {
  switch (value) {
    case "init":
      return (
        <span style={{ color: "#d9a61c", fontWeight: 700 }}>
          {strings.TransactionHistory.Status.Init}
        </span>
      );
    case "progress":
      return (
        <span style={{ color: "#2029a8", fontWeight: 700 }}>
          {strings.TransactionHistory.Status.Progerssing}
        </span>
      );
    case "finished":
      return (
        <span style={{ color: "green", fontWeight: 700 }}>
          {strings.TransactionHistory.Status.Finished}
        </span>
      );
    case "error":
      return (
        <span style={{ color: "red", fontWeight: 700 }}>
          {strings.TransactionHistory.Status.Error}
        </span>
      );
    case "deleted":
      return (
        <span style={{ color: "#730d34", fontWeight: 700 }}>
          {strings.TransactionHistory.Status.Deleted}
        </span>
      );
    default:
      return "";
  }
};

export const getType = (text: string) => {
  switch (text) {
    case "merchant":
      return strings.GlobalLabels.Partner;
    case "supplier":
      return strings.GlobalLabels.Supplier;
  }
};

export const activeStatus = (text: string | number) => {
  switch (text) {
    case "active":
      return (
        <span style={{ color: "darkgreen", fontWeight: 600 }}>
          {strings.GlobalSelections.Active}
        </span>
      );
    case 0:
      return (
        <span style={{ color: "darkgreen", fontWeight: 600 }}>
          {strings.GlobalSelections.Active}
        </span>
      );
    case "inactive":
      return (
        <span style={{ color: "red", fontWeight: 600 }}>
          {strings.GlobalSelections.Inactive}
        </span>
      );
    case 1:
      return (
        <span style={{ color: "red", fontWeight: 600 }}>
          {strings.GlobalSelections.Inactive}
        </span>
      );
    case "import":
      return (
        <span style={{ color: "#cfb11b", fontWeight: 600 }}>
          {strings.GlobalLabels.Import}
        </span>
      );
    case "export":
      return (
        <span style={{ color: "#2769db", fontWeight: 600 }}>
          {strings.GlobalLabels.Export}
        </span>
      );
  }
};

export const getMessage = (
  info: string,
  time: number,
  type: "success" | "error" | "warning"
) => {
  switch (type) {
    case "success":
      return message.success({
        content: info,
        duration: time,
      });
    case "error":
      return message.error({
        content: info,
        duration: time,
      });
    case "warning":
      return message.warning({
        content: info,
        duration: time,
      });
  }
};

export const DescriptionLabels = (
  key: string,
  labels: Record<string, string>
) => {
  let test = Object.entries(labels)?.map(([labelKey, labelVal]) => {
    return {
      label: labelKey,
      value: labelVal,
    };
  });
  do {
    let finalLabels = test?.filter((item) => {
      if (item?.label === key) {
        return item?.value;
      }
    });
    return finalLabels[0]?.value as string;
  } while (!isEmpty(test) || test !== undefined);
};

export const createFormRules = (
  stricted: boolean,
  dataType: string,
  message: string
) => {
  return [
    {
      required: stricted,
      type: dataType,
      message: message,
    },
  ] as FormItemProps["rules"];
};

export const getFormInitialVals = <O extends Object>(
  data: O,
  value: keyof O
) => {
  if (!isEmpty(data)) {
    return data[value];
  } else {
    return undefined;
  }
};

export const convertToISO = (dateStr: {
  $y: number;
  $M: number;
  $D: number;
}) => {
  const year = dateStr.$y;
  const month = dateStr.$M + 1;
  const day = dateStr.$D;
  const isoDate = `${year.toString().padStart(4, "0")}-${month
    .toString()
    .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;
  return isoDate;
};

export const currencyFormat = (value: number | string) => {
  return (
    <span
      style={{
        fontWeight: 550,
        color:
          (value as number) > 0 || parseInt(value as string) > 0
            ? "green"
            : "red",
      }}
    >
      {new Intl.NumberFormat().format(
        typeof value === "string" ? parseInt(value) : value
      )}
    </span>
  );
};

export const labelsRender = (label: string) => {
  return (
    <Col span={24} className="text-center">
      <b style={{ fontSize: 16 }}>{label}</b>
    </Col>
  );
};

export const tooltipFormatter = (value: number, name: string) => {
  const formatMoney = new Intl.NumberFormat().format(value);
  if (name === strings.Generals.TransactionReport.ChartLabels.Total) {
    return formatMoney + strings.GlobalLabels.Currency;
  }
  return formatMoney;
};

export const DataFormater = (number: number) => {
  if (number >= 1000000000) {
    return (number / 1000000000).toString() + " Tỷ";
  } else if (number >= 1000000) {
    return (number / 1000000).toString() + " Triệu";
  } else if (number >= 1000) {
    return (number / 1000).toString() + " Ngàn";
  } else {
    return number.toString();
  }
};

export const handleTableChange = async <T extends Object>(data: {
  pagination?: PaginationsProps | any;
  paramsExport: T;
  needCallbackFunction: boolean;
  apiCallbackFunction?: (value?: T) => Promise<void>;
  setPage: Dispatch<SetStateAction<number>>;
  setPageSize: Dispatch<SetStateAction<number>>;
}) => {
  const {
    setPage,
    setPageSize,
    apiCallbackFunction,
    pagination,
    paramsExport,
    needCallbackFunction,
  } = data;
  setPage(pagination?.current! - 1);
  setPageSize(pagination?.pageSize!);
  if (needCallbackFunction === true) {
    let params: typeof paramsExport = {
      ...paramsExport,
      page: pagination?.current! - 1,
      limit: pagination?.pageSize!,
    };
    await apiCallbackFunction!(params);
  }
};

export const confirmedModalRendering = async (data: {
  handleDelete: () => Promise<void>;
  title?: string | ReactNode;
  width?: number;
  style?: CSSProperties
}) => {
  return Modal.confirm({
    style: data?.style,
    title: !!data?.title
      ? data?.title
      : strings.GlobalMessage.DeleteConfirmation,
    okText: strings.GlobalButtons.Confirm,
    cancelText: strings.GlobalButtons.Cancel,
    centered: true,
    onOk: async () => data?.handleDelete(),
    width: !!data?.width && data?.width,
  });
};

export const paramsChecking = <T extends unknown>(
  value: T | undefined,
  type: "select" | "input"
) => {
  switch (type) {
    case "select":
      return value === strings.GlobalMessage.All ? undefined : value;
    case "input":
      return isEmpty(value) || isUndefined(value) ? undefined : value;
  }
};

export const fetchResponseList = async <
  RequestModel extends Object,
  ResponseModel extends Object[]
>(data: {
  params: RequestModel;
  loadingState: Dispatch<SetStateAction<boolean>>;
  responseState: Dispatch<SetStateAction<ResponseModel>>;
  totalState?: Dispatch<SetStateAction<number>>;
  getListFunction: (
    params: RequestModel
  ) => Promise<BaseApiResponseModel<ResponseModel>>;
}) => {
  const { params, responseState, loadingState, getListFunction, totalState } =
    data;
  try {
    loadingState(true);
    const res = await getListFunction(params);
    if (res) {
      responseState(res?.data);
      totalState!(res?.paging?.total!);
    }
  } catch (error) {
    console.log(error);
    getMessage(`${strings.GlobalMessage.Error}${error?.message}`, 4, "error");
  } finally {
    loadingState(false);
  }
};

export const autoCorrectJSON = (jsonString: string): string => {
  let correctedJSON = jsonString
    .replace(/(?<=\{|\,)\s*([\w]+)\s*:/g, '"$1":')
    .replace(/(?<=:)\s*'([^']*)'\s*(?=,|\}|$)/g, ' "$1"');
  correctedJSON = correctedJSON.replace(/,\s*([\]}])/g, "$1");
  return correctedJSON;
};

export const renderEclipse = (value: string | number) => {
  return (
    <Tooltip
      placement="bottomLeft"
      title={<span style={{ color: "#0f0f0f" }}>{value}</span>}
      color="#f5f7fa"
    >
      {value}
    </Tooltip>
  );
};

export const booleanRendering = (value: boolean | number) => {
  switch (value) {
    case true:
      return (
        <span className="text-green-700 font-semibold">
          {strings.GlobalLabels.Yes}
        </span>
      );
    case false:
      return (
        <span className="text-red-700 font-semibold">
          {strings.GlobalLabels.No}
        </span>
      );
    case 0:
      return strings.GlobalSelections.Online;
    case 1:
      return strings.GlobalSelections.Physical;
    case 2:
      return strings.GlobalSelections.PhysicalTopup;
  }
};

export const avoidDuplicate = (baseInfo: unknown, newInfo: typeof baseInfo) => {
  if (newInfo === baseInfo) {
    return undefined;
  } else {
    return newInfo;
  }
};

export function areEqual(arr1: Array<any>, arr2: Array<any>) {
  let N = arr1.length;
  let M = arr2.length;

  if (N != M) return false;

  arr1.sort();
  arr2.sort();

  for (let i = 0; i < N; i++) if (arr1[i] != arr2[i]) return false;

  // If all elements were same.
  return true;
}

export const dateRendering = (
  dateVal: Array<Record<string, unknown>>,
  key: "from" | "to"
) => {
  switch (key) {
    case "from":
      return moment(dateVal![0]?.$d)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    case "to":
      return moment(dateVal![1]?.$d)
        .add(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
  }
};

export const convertToAntdDate = (date: string) => {
  const [day, month, year] = date.split("/").map(Number);
  return dayjs(new Date(year, month - 1, day));
};

export const findElement = (
  keyword: string,
  array: UserFeatureResponseModel[]
) => {
  if (array?.find((item) => item?.code === keyword)) {
    return true;
  } else {
    return undefined;
  }
};

export const renderActions = (data: {
  keyword: string;
  userFeature: UserFeatureResponseModel[];
  renderType: "detail" | "delete" | "approve";
  onClick: () => void | Promise<void> | unknown;
}) => {
  if (data?.userFeature?.find((item) => item?.code === data?.keyword)) {
    switch (data?.renderType) {
      case "detail":
        return {
          className: "font-semibold",
          type: "primary",
          icon: <EditOutlined />,
          label: strings.GlobalButtons.Details,
          onClick: data?.onClick,
        } as {
          type: ButtonProps["type"];
          label: string;
          className: string;
          onClick: () => Promise<void> | void;
          icon: ReactNode;
        };
      case "delete":
        return {
          className: "font-semibold text-red-700",
          type: "default",
          icon: <DeleteOutlined />,
          label: strings.GlobalButtons.Delete,
          onClick: data?.onClick,
        } as {
          type: ButtonProps["type"];
          label: string;
          className: string;
          onClick: () => void | Promise<void>;
          icon: ReactNode;
        };
      case "approve":
        return {
          className: "font-semibold text-green-700 border-green-700",
          type: "default",
          icon: <CheckCircleOutlined />,
          label: strings.GlobalButtons.Approve,
          onClick: data?.onClick,
        } as {
          type: ButtonProps["type"];
          label: string;
          className: string;
          onClick: () => void | Promise<void>;
          icon: ReactNode;
        };
    }
  } else {
    return undefined
  }
};
